<template>
	<div class="work_order_detail">
		<div class="work_detail">
			<div class="header">
				<span class="title">工单详情</span>
				<div class="dealBtn">
					<span>
						<el-button
							type="default"
							size="small"
							class="hasDeal"
							v-if="detailList.handleType === 0"
							@click="handeleStates(5)"
							>转让工单</el-button
						>
						<el-button
							type="primary"
							size="small"
							class="hasDeal"
							v-if="detailList.handleType === 0"
							@click="handeleStates(4)"
							>作废工单</el-button
						>
						<el-button
							type="primary"
							size="small"
							class="hasDeal"
							v-if="detailList.handleType === 1 || detailList.handleType === 2"
							@click="handeleStates(3)"
							>关闭工单</el-button
						>
						<el-button
							type="primary"
							size="small"
							class="hasDeal"
							v-if="detailList.handleType === 0"
							@click="handeleStates(2)"
							>已处理</el-button
						>
						<el-button
							type="primary"
							size="small"
							class="hasDeal"
							v-if="detailList.handleType === 0"
							@click="handeleStates(1)"
							>无法处理</el-button
						>
					</span>
				</div>
			</div>
			<div class="detail-box">
				<el-row>
					<el-col
						v-for="item in detailbox"
						:key="item.id"
						:span="item.id === 10 ? 24 : 8"
						class="detail-area"
						:class="item.name === '附件：' ? 'accessory' : ''"
					>
						<span>{{ item.name }}</span>
						<sky-upload-img
							v-if="item.name == '附件：'"
							:value="item.value || []"
							disabled="true"
						></sky-upload-img>
						<span v-if="item.name !== '附件：'" class="detail-text">{{ item.value | nullShow }}</span>
					</el-col>
				</el-row>
			</div>
			<!-- 日志 -->
			<div v-if="tableId" class="block">
				<el-row>
					<log-lists ref="logList" :id="tableId"></log-lists>
				</el-row>
			</div>

			<!-- 其他对话框 -->
			<el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
				<span>{{ alertMessage }}</span>
				<span slot="footer" class="dialog-footer">
					<el-button @click="centerDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="submit">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 转交对话框 -->
			<!-- 对话框 -->
			<el-dialog title="转交工单" :visible.sync="deliver" :close-on-click-modal="false" width="30%">
				<form-combination
					:form-data="deliverContent"
					ref="deliverContent"
					label-width="120px"
				></form-combination>
				<span slot="footer" class="dialog-footer">
					<el-button @click="deliver = false">取消</el-button>
					<el-button type="primary" @click="submit('deliverContent')">确定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import workOrder from '@/backend/services/workOrder/workOrder.js';
import logLists from '@/components/workOrder/logLists';
import skyUploadImg from '@/components/iglobalwin/formComponents/sky-uploadimg';
import { validRequired } from '@/common/elementValid.js';
import formCombination from '@/components/iglobalwin/formCombination/formCombination.vue';
import userSearch from '@/components/tools/userSearch';

import { mapGetters } from 'vuex';
export default {
	name: 'workOrderDetail',
	components: {
		logLists,
		skyUploadImg,
		formCombination,
	},
	data() {
		return {
			detailbox: [],
			detailList: {
				fileContentList: [],
			},
			createrId: '',
			workOrderId: '',
			tableId: '',
			centerDialogVisible: false,
			alertMessage: '',
			handleType: '',
			imgUrl: '../../assets/skycloudLogin.png',
			deliver: false,
			deliverContent: {
				takeOverId: {
					label: '转交给',
					formType: userSearch,
					value: '',
					rules: [validRequired('此项必填', 'blue')],
				},
				remarks: {
					label: '备注',
					formType: 'sky-textarea',
					value: '',
				},
			},
			// creater: false
			// handle: false
		};
	},
	computed: {
		...mapGetters(['userId']),
	},
	mounted() {
		this.tableId = this.$route.query.id;
		this.getWorkOrderInfo();
	},
	methods: {
		// 获取详情页数据
		async getWorkOrderInfo() {
			const id = this.$route.query.id;
			let res = await workOrder.getWorkOrderInfo(id);
			this.detailList = res.data;
			// 提交人
			// if (this.detailList.createrId == this.userId) {
			//   this.creater = true
			// }
			// 处理人
			// if (this.detailList.handleId == this.userId) {
			//   this.handle = true
			// }

			let {
				workOrderCode,
				customerName,
				orderCode,
				workOrderTypeStr,
				domainName,
				problemTypeStr,
				remarks,
				handleTypeStr,
				handleName,
				fileContentList,
				createTimeStr,
				createrName,
				departmentName,
			} = this.detailList;
			// 工单详情数据
			this.detailbox = [
				{ id: 1, name: '工单编号：', value: workOrderCode },
				{ id: 2, name: '客户名称：', value: customerName },
				{ id: 3, name: '关联订单：', value: orderCode },
				{ id: 4, name: '工单类型：', value: workOrderTypeStr },
				{ id: 5, name: '域名：', value: domainName },
				{ id: 6, name: '问题类型：', value: problemTypeStr },
				{ id: 7, name: '备注：', value: remarks },
				{ id: 8, name: '处理状态：', value: handleTypeStr },
				{ id: 9, name: '当前处理人：', value: handleName },
				{ id: 10, name: '附件：', value: fileContentList },
				{ id: 11, name: '创建时间：', value: createTimeStr },
				{ id: 12, name: '发起人：', value: createrName },
				{ id: 13, name: '部门：', value: departmentName },
			];
			// 更新日志
			if (this.$refs.logList) this.$refs.logList.getWorkOrderlog();
		},

		// 点击按钮显示模态框
		handeleStates(item) {
			if (item !== 5) {
				// 显示模态框
				this.centerDialogVisible = true;
			}
			// 无法处理
			if (item == 1) {
				this.alertMessage = '确定无法处理此工单？';
				this.handleType = item;
				return;
			}
			// 已处理
			if (item == 2) {
				this.alertMessage = '确定处理完此工单？';
				this.handleType = item;
				return;
			}
			// 关闭工单
			if (item == 3) {
				this.alertMessage = '确定关闭此工单？';
				this.handleType = item;
				return;
			}
			// 作废工单
			if (item == 4) {
				this.alertMessage = '确定作废此工单？';
				this.handleType = item;
				return;
			}
			// 转交工单
			if (item == 5) {
				this.deliver = true;
				this.handleType = item;
			}
		},

		// 改变工单状态
		async submit(deliverContent) {
			var index = true;
			// 非空校验
			if (this.handleType === 5) {
				this.$refs[deliverContent].validate(valid => {
					if (!valid) {
						index = false;
						return false;
					}
				});
			}
			// 关闭工单校验
			if (this.handleType === 3) {
				let { handleType } = this.detailList;

				if (handleType !== 1 && handleType !== 2) {
					index = false;
					this.$message({
						message: '工单状态为已处理或无法处理才可关闭',
						type: 'warning',
					});
				}
			}
			// 空值截取
			if (!index) {
				return false;
			}
			// 发送请求
			let res = await workOrder.operation({
				handleType: this.handleType,
				workOrderId: this.detailList.workOrderId,
				takeOverId: this.deliverContent.takeOverId.value,
				remarks: this.deliverContent.remarks.value,
			});

			// 请求结果处理
			if (res.status == 200) {
				this.deliver = false;
				this.centerDialogVisible = false;
				this.getWorkOrderInfo();
				this.deliverContent.takeOverId.value = '';
				this.deliverContent.remarks.value = '';
				this.$message({
					message: '工单修改成功',
					type: 'success',
				});
			}
		},
	},
	filters: {
		nullShow(val) {
			return val == undefined || val == null ? '-' : val;
		},
	},
};
</script>

<style scoped lang="scss">
.work_detail {
	margin: 0 auto;
	width: 100%;
	// height: 900px;
	.header {
		display: flex;
		width: 100%;
		padding: 20px;
		background-color: #fff;
		justify-content: space-between;
		.title {
			font-size: 20px;
			font-weight: 700;
		}
	}
	.detail-box {
		width: 100%;
		padding: 0 20px 30px;
		margin-bottom: 60px;
		background: #ffffff;
		position: relative;
		.dealBtn {
			display: flex;
			justify-content: flex-end;
		}

    .detail-text {
      white-space: pre-line;
    }
	}
	.detail-box:after {
		content: '';
		position: absolute;
		bottom: 65px;
		left: 0;
		width: 100%;
		height: 1px;
		background-color: #ccc;
	}
	.closeServiceOrder {
		margin-right: 10px;
	}
	.detail-item {
		margin-bottom: 20px;
		line-height: 40px;
	}
	.detail-area {
		margin-top: 20px;
	}
	.accessory {
		margin-bottom: 30px;
	}
	.uploadImg {
		// margin-left: 20px;
		margin-top: 20px;
	}
}
</style>
